import { Link, useLocation } from "react-router-dom";
import { Icon } from "semantic-ui-react";

import { PATHS } from "router/paths";

export const AppointmentsButton = () => {
  const location = useLocation();

  if (!(location.pathname === PATHS.DAYPLANNER)) return null;

  return (
    <Link className="button" to={PATHS.APPOINTMENTS}>
      <Icon className="list solid regular i-grey" />
    </Link>
  );
};
